import { defineComponent as _defineComponent } from 'vue'
import ajax from "JS/utilities/ajax";
import BButton from "JS/components/BButton.vue";
import CarouselTrackingService from 'JS/services/CarouselTrackingService';
import QuickAddProductDetails from "JS/components/side-menus/add-to-cart/QuickAddProductDetails.vue";
import SalesFlyerSearchForm from "../SalesFlyerSearchForm.vue";
import Spinner from 'JS/components/Spinner.vue';
import { computed, ref, watch } from 'vue';
import { createCarouselViewGtmData } from 'JS/utilities/carousel-tracking';
import { getSalesFlyerPageProductListLink, SalesFlyerProductSearch } from "JS/sales-flyer/utilities/product-list";
import { SalesFlyerSidePanelResource } from "JS/sales-flyer/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerSideMenuContents',
  props: {
    search: null,
    flyerTitle: null
  },
  setup(__props: any) {

const props = __props as {
	search?: SalesFlyerProductSearch | null;
	flyerTitle: string;
}



const resource = ref<SalesFlyerSidePanelResource | null>(null);
const isLoading = ref<boolean>(false);
const maxHitError = ref<string>("");
const customCarouselID = computed(()=> `sales_flyer_${props.search?.promoNumber}`);

const shopAllLink = computed(() => {
	if (!props.search) {
		return null;
	}

	return getSalesFlyerPageProductListLink({
		promoNumber: props.search.promoNumber,
		pageNumber: props.search.pageNumber,
		keyword: keyword.value?.trim() || undefined,
	});
});

const eligibleProductsLabel = computed(() => {
	if (isLoading.value) {
		return null;
	}
	const { totalProducts } = resource.value ?? { totalProducts: 0 };

	const s = totalProducts === 1 ? "" : "s";

	if (keyword.value) {
		return `${totalProducts} result${s} for "${keyword.value}"`;
	}

	return `${totalProducts} Eligible Product${s}`;
});

const hasProducts = computed(() => !!resource.value?.products?.length);

const currentPageNumber = computed(() => resource.value?.pageNumber ?? props.search?.pageNumber);
const title = computed(() => {
	if (currentPageNumber.value != null) {
		return `Page ${currentPageNumber.value} Deals`;
	}

	return `${props.flyerTitle} Deals`;
});

const searchFormLabelProps = computed(() => {
	const initialValue = keyword.value;
	if (currentPageNumber.value != null) {
		return {
			label: `Search page ${currentPageNumber.value} deals`,
			ariaLabel: `Search in page ${currentPageNumber.value} of '${props.flyerTitle}' Sales Flyer`,
			initialValue,
		};
	}

	return {
		label: 'Search deals',
		ariaLabel: `Search for deals in the '${props.flyerTitle}' Sales Flyer`,
		initialValue,
	};
});

const keyword = ref(props.search?.keyword ?? '');
function handleSubmit(value: string) {
	keyword.value = value;
}

const carouselTrackingService = new CarouselTrackingService();

watch(
	[
		() => props.search?.promoNumber,
		() => props.search?.pageNumber,
		keyword
	],
	async ([promoNum, pageNum, keyword], _, onCleanup) => {
		if (promoNum == null) {
			isLoading.value = false;
			return;
		}

		isLoading.value = true;

		const params = new URLSearchParams({
			promoNumber: promoNum.toString(),
		});

		if (pageNum != null) {
			params.set('pageNumber', pageNum.toString());
		}

		if (keyword?.trim()) {
			params.set("keyword", keyword);
		}

		const ac = new AbortController();
		onCleanup(() => ac.abort());

		const res: SalesFlyerSidePanelResource = await ajax.get(`/sales-flyer/side-panel/?${params.toString()}`);

		if (ac.signal.aborted) {
			return;
		}

		if (res != null) {
			resource.value = res;

			if (res.products.length) {
				//Same tracking as the ATC Quick ads sidemenu
				const viewImpressionUrl = (window.location.pathname + window.location.search);
				const gtmData = createCarouselViewGtmData(resource.value, customCarouselID.value);

				carouselTrackingService.trackViews([gtmData]);
			}
		}

		isLoading.value = false;
	},
	{
		immediate: true,
	}
);


return { __sfc: true,props, resource, isLoading, maxHitError, customCarouselID, shopAllLink, eligibleProductsLabel, hasProducts, currentPageNumber, title, searchFormLabelProps, keyword, handleSubmit, carouselTrackingService, BButton, QuickAddProductDetails, SalesFlyerSearchForm, Spinner }
}

})